import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../../Shared/AdminNavbar/Navbar';
import axios from 'axios';
import baseURL from '../../../Apiurs/Apiurls';
import ReusableTable from '../../../Layout/ReusableTable';
import './Quotation.css';
import './../../../Layout/Collapse/Collapse.css';
import { FaHistory } from 'react-icons/fa';

const Quotationpage = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [quotations, setQuotations] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();

  // Fetch all latest quotations
  useEffect(() => {
    const fetchQuotations = async () => {
      try {
        const res = await axios.get(`${baseURL}/api/quotations`);
        setQuotations(res.data);
        setFilteredData(res.data); // for ReusableTable
      } catch (err) {
        console.error('Failed to fetch quotations:', err);
      }
    };
    fetchQuotations();
  }, []);

  // Columns for ReusableTable
  const columns = [
    { 
      key: 'lead_id', 
      title: 'Lead ID', 
      render: (row) => `Lead${String(row.lead_id).padStart(4, '0')}` 
    },
    { 
      key: 'quotation_number', 
      title: 'Quotation Number', 
      render: (row) => (
        <span
          className="text-primary cursor-pointer "
          style={{ cursor: 'pointer' }}
          onClick={() => navigate(`/previewquotation/${row.lead_id}`)}
        >
          {row.quotation_number}
        </span>
      )
    },
{
  key: 'created_at',
  title: 'Quotation Date',
  render: (row) => {
    if (!row.created_at) return '-';
    const date = new Date(row.created_at);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  },
}  ,
  { key: 'subtotal', title: 'Sub Total', render: (row) => row.subtotal },
    { key: 'gst', title: 'GST', render: (row) => row.gst },
    { key: 'total_amount', title: 'Total Amount', render: (row) => row.total_amount },
    {
      key: 'action',
      title: 'Action',  
      render: (row) => (
      


                    <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => navigate(`/a-opp-view-sent-quotations/${row.lead_id}`, )}
            title="History"
          >
            <FaHistory />
          </button>
        
      ),
    },
  ];

  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? 'collapsed' : ''}`}>
        <div className="table-container p-3">
          <ReusableTable
            data={filteredData}
            columns={columns}
            initialEntriesPerPage={5}
            searchPlaceholder="Search leads..."
          />
        </div>
      </div>
    </div>
  );
};

export default Quotationpage;